var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('base-overlay',{attrs:{"loading":_vm.fetching}},[_c('b-table',{attrs:{"striped":"","items":_vm.admins,"fields":_vm.tableColumns,"show-empty":"","empty-text":"No linked admins"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }